import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PersonnelSection = ({ personnel, onChange }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleAddPerson = () => {
    if (searchTerm?.trim()) {
      onChange([...personnel, { id: Date.now(), name: searchTerm }]);
      setSearchTerm('');
    }
  };

  const handleRemovePerson = (id) => {
    onChange(personnel?.filter(p => p?.id !== id));
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Personnel Involved</h3>
      <div className="mb-4">
        <div className="flex gap-2">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
            placeholder="Search employee name or ID..."
            className="flex-1 px-4 py-3 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
            onKeyPress={(e) => e?.key === 'Enter' && handleAddPerson()}
          />
          <button
            type="button"
            onClick={handleAddPerson}
            className="px-4 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors"
          >
            <Icon name="Plus" size={20} />
          </button>
        </div>
      </div>
      {personnel?.length > 0 && (
        <div className="space-y-2">
          {personnel?.map((person) => (
            <div key={person?.id} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
                  <Icon name="User" size={16} className="text-primary" />
                </div>
                <span className="text-foreground">{person?.name}</span>
              </div>
              <button
                type="button"
                onClick={() => handleRemovePerson(person?.id)}
                className="text-red-500 hover:text-red-600 transition-colors"
              >
                <Icon name="X" size={18} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PersonnelSection;